import { AxiosError } from 'axios';
import client from 'client';
import { useMutation, useQueryClient } from 'react-query';
import { LocationType, MeetingStatus, ScheduledMeetingParticipant } from '../types';
import { MeetingsHttpKey } from '../ManageMeetings/useMeetingsData';

const CONFLICT_STATUS_CODE = 409;

type CreateMeetingRequest = {
    locationType: LocationType;
    physicalLocation?: string;
    members: {
        userProfileId: number;
        required: boolean;
    }[];
    title?: string;
    intro?: string;
    description?: string;
    selectedTimes: Date[];
};

type CreateMeetingRespone = {
    id: string;
    status: MeetingStatus;
    participants: ScheduledMeetingParticipant[];
    title?: string;
    duration: number;
    locationType: LocationType;
    physicalLocation?: string;
    description?: string;
    times: string[];
};

const createMeeting = async ({ eventId, req }: { eventId: number; req: CreateMeetingRequest }) => {
    return await client().post<CreateMeetingRespone>(
        `/api/v2/meetings/events/${eventId}/scheduledMeetings`,
        {
            ...req,
            // TODO: the below shouldn't be necessary in the future
            source: { type: 'CHAT', id: 0 },
            meetingChannel: {
                type: 'VIDEO',
                subtype: 'AGORA',
            },
        }
    );
};

const useCreateMeeting = () => {
    const queryClient = useQueryClient();
    return useMutation(createMeeting, {
        onMutate: () => {
            queryClient.cancelQueries(MeetingsHttpKey.Meetings);
            queryClient.cancelQueries(MeetingsHttpKey.MeetingsTotal);
            queryClient.cancelQueries(MeetingsHttpKey.MeetingsGroups);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries(MeetingsHttpKey.Meetings);
            await queryClient.invalidateQueries(MeetingsHttpKey.MeetingsTotal);
            queryClient.invalidateQueries(MeetingsHttpKey.MeetingsGroups);
        },
        useErrorBoundary: (error: AxiosError) => error.response?.status !== CONFLICT_STATUS_CODE,
    });
};

export default useCreateMeeting;
